var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoofTerrace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M291.276,27.892l-280.714,-27.829c-0.365,-0.042 -0.732,-0.063 -1.1,-0.063c-5.31,-0 -9.68,4.37 -9.68,9.68c0,5.004 3.881,9.226 8.868,9.645l271.99,26.965l0,17.248l-271.034,-0c-5.31,-0 -9.68,4.37 -9.68,9.68c0,5.31 4.37,9.68 9.68,9.68l218.401,-0l-0,197.83l-68.364,0l-0,-74.413l39.929,-0c5.31,-0 9.68,-4.37 9.68,-9.68c-0,-5.31 -4.37,-9.68 -9.68,-9.68l-99.218,0c-5.31,0 -9.68,4.37 -9.68,9.68c0,5.31 4.37,9.68 9.68,9.68l39.929,-0l0,74.413l-31.459,0l0,-47.794c0,-5.31 -4.37,-9.679 -9.68,-9.679l-47.794,-0l0,-56.869c0,-5.31 -4.369,-9.68 -9.68,-9.68c-5.31,-0 -9.679,4.37 -9.679,9.68l-0,114.342l-22.385,0c-5.31,0 -9.68,4.37 -9.68,9.68c0,5.31 4.37,9.68 9.68,9.68l251.675,-0c5.31,-0 9.68,-4.37 9.68,-9.68c-0,-5.31 -4.37,-9.68 -9.68,-9.68l-13.915,0l0,-197.83l42.954,-0c5.31,-0 9.68,-4.37 9.68,-9.68l-0,-35.695c-0.001,-4.95 -3.798,-9.142 -8.724,-9.631Zm-239.926,214.722l38.114,0l0,38.114l-38.114,0l0,-38.114Zm238.02,57.426c-8.469,-0.823 -11.888,-11.58 -5.19,-17.116c1.987,-1.621 4.537,-2.394 7.09,-2.147c12.668,1.21 10.89,20.485 -1.9,19.263Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofTerrace);
export default __webpack_public_path__ + "static/media/roof_terrace.b48b845f.svg";
export { ForwardRef as ReactComponent };